import React, { useState } from 'react';
import './form.css';
import TextField from './text';

const Form = () => {
    const [weight, setWeight] = useState("");
    const [height, setHeight] = useState("");
    const [bmi, setBmi] = useState(0);
    const [message, setMessage] = useState("");

    function calculateBMI() {
        const bmiValue = weight / (height * height);
        setBmi(bmiValue.toFixed(2)); // Round BMI value to two decimal places
        setMessage(getBMIMessage(bmiValue));
    }

    function getBMIMessage(bmiValue) {
        if (bmiValue < 18.5) {
            return "Underweight";
        } else if (bmiValue >= 18.5 && bmiValue <= 24.9) {
            return "Normal";
        } else if (bmiValue >= 25 && bmiValue <= 29.9) {
            return "Overweight";
        } else {
            return "Obese";
        }
    }

    function resetForm() {
        setWeight("");
        setHeight("");
        setBmi(0);
        setMessage("");
    }

    return (
        <div className='container-form container r '>
           
            <div className="card-style card p-5 text-light" style={{ width: '400px',
                height: '500px' }}>
                    <TextField />
                <form>
                    <h2 className="text-center text-light" style={{
                        fontSize: '30px',
                        fontWeight: 'bold'
                    }}>BMI Calculator</h2>
                    <div className="mb-3">
                        <label htmlFor="weightInput" className="form-label ">Weight (kg)</label>
                        <input type="number" className="form-control" id="weightInput" value={weight} onChange={(e) => setWeight(e.target.value)} />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="heightInput" className="form-label">Height (m)</label>
                        <input type="number" className="form-control" id="heightInput" value={height} onChange={(e) => setHeight(e.target.value)} />
                    </div>
                    <div className='btn-container'>
                        <button type="button" className="btn btn-primary" onClick={calculateBMI}>Check</button>
                        <button type="button" className="btn btn-danger" onClick={resetForm}>Reset</button>
                    </div>
                </form>
                {bmi > 0 && (
                    <div className="result card text-center mt-4 text-dark">
                        <p className='first-text'>BMI: <span>{bmi}</span></p>
                        <p className='second-text'>{message}</p>
                    </div>
                )}
               
            </div>
            
        </div>
    );
}

export default Form;
